import React, { createContext } from 'react';

import { IOrdersRecognitionContextValues } from '@widgets/OrdersRecognition/model/types';

export const OrdersRecognitionContext = createContext<IOrdersRecognitionContextValues>(null);

export const OrdersRecognitionContextProvider = ({
    contextValues,
    children,
}: {
    contextValues: IOrdersRecognitionContextValues;
    children: React.ReactNode;
}) => (
    <OrdersRecognitionContext.Provider value={contextValues}>
        {children}
    </OrdersRecognitionContext.Provider>
);
